"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var moment = require("moment");
var PropTypes = require("prop-types");
var DatePickerRangeInternal = /** @class */ (function (_super) {
    __extends(DatePickerRangeInternal, _super);
    function DatePickerRangeInternal(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Callback used for the onChange for the "end" datepicker
         */
        _this.onEndChange = function (date) {
            var startDate = _this.state.startDate;
            var newState = { endDate: date };
            if (!startDate || date < startDate) {
                newState.startDate = date;
            }
            _this.setState(newState, _this.onChange);
        };
        /**
         * Callback used for the onChange for the "start" datepicker
         */
        _this.onStartChange = function (date) {
            var endDate = _this.state.endDate;
            var newState = { startDate: date };
            if (!endDate || date > endDate) {
                newState.endDate = date;
            }
            _this.setState(newState, _this.onChange);
        };
        var initialEndDate = props.initialEndDate, initialStartDate = props.initialStartDate, selectDateAndTime = props.selectDateAndTime, utcOffset = props.utcOffset;
        var endDate;
        var startDate;
        if (initialEndDate) {
            endDate = moment(initialEndDate);
            // Ensure correct UTC offset in case we're going to "zero" to start of day
            endDate.utcOffset(utcOffset);
            endDate = selectDateAndTime
                ? endDate.toDate()
                : endDate.startOf("day").toDate();
        }
        if (initialStartDate) {
            startDate = moment(initialStartDate);
            // Ensure correct UTC offset in case we're going to "zero" to start of day
            startDate.utcOffset(utcOffset);
            startDate = selectDateAndTime
                ? startDate.toDate()
                : startDate.startOf("day").toDate();
        }
        _this.state = { endDate: endDate, startDate: startDate };
        return _this;
    }
    /**
     * Used to call consumers on change when the state is updated.
     */
    DatePickerRangeInternal.prototype.onChange = function () {
        var onChange = this.props.onChange;
        var _a = this.state, endDate = _a.endDate, startDate = _a.startDate;
        onChange && onChange({ endDate: endDate, startDate: startDate });
    };
    /**
     * Type guard function to determine if the passed argument is a QuickLink
     */
    DatePickerRangeInternal.prototype.isQuickLink = function (link) {
        return link.date !== undefined;
    };
    /**
     * Helper to turn a mixed list of `QuickLink | QuickRangeLink` into a list of
     * `QuickLinkInternal` with onClick handlers to handle range selection.
     */
    DatePickerRangeInternal.prototype.getQuickLinks = function (links) {
        var _this = this;
        var _a = this.props, selectDateAndTime = _a.selectDateAndTime, utcOffset = _a.utcOffset;
        return links.map(function (link) {
            // Normal QuickLink? Just return it.
            if (_this.isQuickLink(link)) {
                return link;
            }
            // Otherwise turn `QuickRangeLink` into `QuickLinkInternal`
            var momentEndDate = moment(link.endDate);
            var momentStartDate = moment(link.startDate);
            // Ensure correct UTC offset since we're going to "zero" to start of day
            momentEndDate.utcOffset(utcOffset);
            momentStartDate.utcOffset(utcOffset);
            return {
                date: undefined,
                onClick: function () {
                    return _this.setState({
                        endDate: selectDateAndTime
                            ? momentEndDate.toDate()
                            : momentEndDate.startOf("day").toDate(),
                        startDate: selectDateAndTime
                            ? momentStartDate.toDate()
                            : momentStartDate.startOf("day").toDate()
                    }, _this.onChange);
                },
                text: link.text
            };
        });
    };
    DatePickerRangeInternal.prototype.render = function () {
        var _a = this.props, dateFormat = _a.dateFormat, monthsShown = _a.monthsShown, quickLinks = _a.quickLinks, utcOffset = _a.utcOffset;
        var _b = this.state, endDate = _b.endDate, startDate = _b.startDate;
        var datePickerProps = {
            dateFormat: dateFormat,
            endDate: endDate,
            monthsShown: monthsShown,
            startDate: startDate,
            utcOffset: utcOffset,
            quickLinks: quickLinks && this.getQuickLinks(quickLinks)
        };
        var endDatePickerProps = __assign({}, datePickerProps, { onChange: this.onEndChange, selectsEnd: true, value: endDate });
        var startDatePickerProps = __assign({}, datePickerProps, { onChange: this.onStartChange, selectsStart: true, value: startDate });
        return this.props.children({ endDatePickerProps: endDatePickerProps, startDatePickerProps: startDatePickerProps });
    };
    DatePickerRangeInternal.defaultProps = {
        selectDateAndTime: false,
        monthsShown: 2,
        utcOffset: 0
    };
    DatePickerRangeInternal.propTypes = { children: PropTypes.func.isRequired };
    return DatePickerRangeInternal;
}(React.Component));
/**
 * OUI datepicker range component.
 * A datepicker range should be used when a user needs to pick a date range.
 *
 * @oui-component DatePickerRange
 */
var DatePickerRange = function (props) { return (React.createElement(DatePickerRangeInternal, __assign({}, props))); };
exports.default = DatePickerRange;
//# sourceMappingURL=DatePickerRange.js.map